import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { UserProfile } from '@/integrations/supabase/types/user.types';

export const useAffiliateEligibility = (userProfile?: UserProfile | null) => {
  return useQuery({
    queryKey: ['affiliate-eligibility-details', userProfile?.id],
    queryFn: async () => {
      console.log('Checking eligibility for user:', userProfile?.id);
      
      if (!userProfile?.id) {
        return {
          isPremium: false,
          activityMonths: 0,
          isEligible: false,
          isAffiliate: false
        };
      }

      // Check if user is already an affiliate
      const { data: affiliateData } = await supabase
        .from('affiliates')
        .select('id')
        .eq('user_id', userProfile.id)
        .single();

      // Verificar tiempo de suscripción premium
      const { data: subscriptionData } = await supabase
        .from('subscriptions')
        .select('created_at, status')
        .eq('user_id', userProfile.id)
        .eq('status', 'active')
        .single();

      // Calcular meses de suscripción premium
      let premiumMonths = 0;
      if (subscriptionData) {
        const subscriptionStart = new Date(subscriptionData.created_at);
        const now = new Date();
        const diffTime = Math.abs(now.getTime() - subscriptionStart.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        premiumMonths = Math.floor(diffDays / 30);
      }

      console.log('Premium months:', premiumMonths);
      console.log('Subscription data:', subscriptionData);

      const isPremium = !!subscriptionData && subscriptionData.status === 'active';

      return {
        isPremium,
        activityMonths: premiumMonths,
        isEligible: isPremium && premiumMonths >= 3,
        isAffiliate: !!affiliateData
      };
    },
    enabled: !!userProfile?.id
  });
};